import { render, staticRenderFns } from "./LoanDetailsHistory.vue?vue&type=template&id=602b55d9"
import script from "./LoanDetailsHistory.vue?vue&type=script&lang=js"
export * from "./LoanDetailsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports